// featureName of the UpgradePopup a free user sees at the 3-book limit (MyBooks, BooksMyJournal);
// UpgradePopup shows its book-limit copy for it. Kept out of UpgradePopup.js so pages still get it
// in tests that mock the popup.
export const BOOK_LIMIT_FEATURE = 'Creating 3+ books'
